import { render, staticRenderFns } from "./PuzzleLoopCreate.vue?vue&type=template&id=38b6b292"
import script from "./PuzzleLoopCreate.vue?vue&type=script&lang=js"
export * from "./PuzzleLoopCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports